import React from 'react';
import { Link } from 'react-router-dom';
import './Contact.css';
import logo from '../Assets/images/logo.jpg';

const Contact = () => {
  return (
    <div className="contact-page">
     
      <header className="navbar">
        <div className="top-bar">
          <span>📍 Juffair - Bahrain</span>
          <span>📧 support@limoxyworld.com</span>
          <span>⏰ 24/7 Available</span>
        </div>
        <div className="main-nav">
          <div className="logo-container">
            <img src={logo} alt="Limoxy Logo" className="logo-image" />
            <span className="logo-text">LIMOXY</span>
          </div>
          <nav>
            <a href="/">Home</a>
            <a href="/about">About Us</a>
            <a href="/services">Our Services</a>
            <a href="/contact">Contact</a>
            <a href="/partner">Partner</a>
          </nav>
          <Link to="/Bookride">
                        <button className="book-btn">Book Your Ride</button>
                    </Link>
        </div>
      </header>

      
      <section className="contact-section">
        <h1>Contact Us</h1>
        <p>We are available 24/7. Reach out to us for bookings, inquiries, or partnerships.</p>

        <div>
          
         

         
          <div className="contact-info">
            <h3>Contact Details</h3>
            <p><strong>📍 Address:</strong> Juffair, Manama, Bahrain</p>
            <p><strong>📧 Email:</strong> support@limoxyworld.com</p>
            <p><strong>📞 Phone:</strong> +973 1234 5678</p>
           
          </div>
        </div>
      </section>

      
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-logo">
            <img src={logo} alt="Limoxy Logo" className="footer-logo-img" />
            <h3>Limoxy World</h3>
          </div>
          <p>Global chauffeur excellence in 45,000+ cities. Drive with trust, luxury, and ease.</p>
          <div className="footer-links">
            <a href="/">Home</a>
            <a href="/about">About</a>
            <a href="/services">Services</a>
            <a href="/contact">Contact</a>
            <a href="/partner">Partner</a>
          </div>
          <p className="footer-bottom">© {new Date().getFullYear()} Limoxy World. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default Contact;